import { render } from "./UpdateMenuItem.vue?vue&type=template&id=fb7b6c52&scoped=true"
import script from "./UpdateMenuItem.vue?vue&type=script&lang=js"
export * from "./UpdateMenuItem.vue?vue&type=script&lang=js"

import "./UpdateMenuItem.vue?vue&type=style&index=0&id=fb7b6c52&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\POS-SYSTEM-BACKUP-STRIPE\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb7b6c52"]])

export default __exports__